import { createFeatureSelector, createSelector } from "@ngrx/store";
import { levelFeatureKey, LevelState } from "../reducers/level.reducer";

export const selectLevelState = createFeatureSelector<LevelState>(levelFeatureKey);

export const selectLevels = createSelector(
  selectLevelState,
  (state: LevelState) => state.levels,
);
